import React from "react";

import { CLOSED_APC_TYPE_OPTIONS } from "../../../data";
import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import {
  AccessoryQuantityCard,
  AccessoryQuantityNoteCard,
  AccessoryTypeQuantityNoteCard,
} from "./AccessoriesCards";
import { OpenBasketCard, ToolboxCard } from "./AccessoriesStorage";
import { closedKey } from "./BoxStructureCards";

const AccessoriesTying = () => (
  <>
    <StructureSection titleKey={closedKey("SECTIONS.TYING")} plain>
      <CardRow columns={2}>
        <AccessoryQuantityNoteCard
          cardKey="recessedRings"
          titleKey={closedKey("CARDS.RECESSED_RINGS")}
        />
        <AccessoryTypeQuantityNoteCard
          cardKey="apcRings"
          titleKey={closedKey("CARDS.APC_RINGS")}
          options={CLOSED_APC_TYPE_OPTIONS}
        />
      </CardRow>
    </StructureSection>

    <StructureSection titleKey={closedKey("SECTIONS.STORAGE")}>
      <CardRow columns={2}>
        <ToolboxCard />
        <AccessoryQuantityCard
          cardKey="palletJackMount"
          titleKey={closedKey("CARDS.PALLET_JACK_MOUNT")}
        />
      </CardRow>
      <CardRow columns={2}>
        <OpenBasketCard />
        <AccessoryQuantityCard
          cardKey="jerrycan"
          titleKey={closedKey("CARDS.JERRYCAN")}
        />
      </CardRow>
    </StructureSection>
  </>
);

export default AccessoriesTying;
